
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {IPage} from "@/js/page";
    import {mechanismApi, userApi, dictApi, manufactoryApi,mechanismNameApi} from "@/api/organization";
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import baseUrl, {imageUrl} from "@/constants";
    import OrganizationTable from "@/components/OrganizationTable.vue"   //审核用的复杂版
    import OrganizationTable2 from "@/components/OrganizationTable2.vue"
    import AddManufactory from "@/components/AddManufactory.vue"; //简单版
    import reasons from "@/components/Reasons2.vue";
import router from "@/router";
    const {CodeToText, regionData} =require("@/js/region/region");

    @Component({
        name: "mechanismList",
        components: {SetTableColumns,OrganizationTable, OrganizationTable2, AddManufactory, reasons}
    })
    export default class Home extends Vue {
        @Prop()
        propQuery: any;

        @Prop()
        tableHeight: any;

        // titles = ['计量器具使用单位', '法定计量技术机构', '其他计量技术机构', '计量行政管理部门', '计量器具制造单位', '所在单位管理'];
        imageUrl = imageUrl
        baseUrl = baseUrl
        listTotal = 0;
        listData = [];
        sysMechanismDelete = false;
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        propParams = {//查询参数
            region: '',
            organizationId: "",
            organizationType: null as any, //0 ： 计量器具使用单位 1：法定计量技术机构 2：其他计量技术机构 3：计量行政管理部门 4：计量器具制造单位
        }
        form = {
            code: "",  //单位代码
            name: "",  //单位名称
            realName: "",  //联系人
            phone: "",  //手机号
            employeeCount: "",  //编制人数
            certCount: "",  //资质证书
            organizationType: "", // 单位类型
            activeStatus: "", //活动状态1（正常）2（禁用）
            warnStatus: "", //预警状态1（正常）2（预警）3（超期）
            area: "",  //区域
        } as any
        showForm = false;
        CodeToText = CodeToText
        mechanismDetail = { //单位详情
            visible: false,
            detail: null as any,
            updateVisible: false,
        }
        mechanismNameDetail = { //单位名称详情
            visible: false,
            updateVisible: false,
            item: {
                id:0,
                name:"",
                mechanismId:"",
            },
            mechanismId:"",
        }
        updateFrom = null as any
        failDialog = false
        failText = ""
        formRules = {
            code: [{required: true, message: '请输入统一社会信用代码', trigger: 'blur'}],
            name: [{required: true, message: '请输入单位名称', trigger: 'blur'}],
            regions: [{required: true, message: '请选择单位所属区域'}],
            residence: [{required: true, message: '请输入单位注册地址', trigger: 'blur'}],
            userName: [{required: true, message: '请输入联系人', trigger: 'blur'}],
            userMobile: [{required: true, message: '请输入手机号', trigger: 'blur'}],
            location: [{required: true, message: '请选择单位地理位置', trigger: 'blur'}],
            postalAddress: [{required: true, message: '请输入单位通讯地址', trigger: 'blur'}],
            level: [{required: true, message: "请选择单位级别", trigger: "blur"}],
            realName: [{required: true, message: '请输入联系人', trigger: 'blur'}],
            landline: [{required: true, message: '请输入联系电话', trigger: 'blur'}],
            // email: [{required: true, message: '请输入单位邮箱', trigger: 'blur'}],
            // postcode: [{required: true, message: '请输入邮政编码', trigger: 'blur'}],
            // fax: [{required: true, message: '请输入单位传真', trigger: 'blur'}]
        }
        certDetail = { //证书列表
            visible: false,
            list: [],
        }
        levelData = {}
        mechanismTypeData = {}
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        tabCol = [];
        allSelected = [];
        load = false;
        private closePage: any;
        private exportExcel: any;
        regionData = regionData //省市区三级联动带全部
        selectedOptions = []// 省市区选中数组
        status = "1";  //0未审核  1已审核
        bindList = "0";  //0普通列表  1绑定单位的备选列表
        userData = {} as any;
        userLoginInfoStatus = 0;
        manufacture = "0"; // 是否是制造单位
        mechanismTypeList = [];
        levels = [];
        mechanismNameList = [];//单位名称列表
        allSelectedExamine = [];
        tableKey = 0;
        leastNumber = 4;
        fullScreen = false;
        changeApplyDialog = {
          visible: false,
          docType: "YYZZ"
        };

        created() {
            const route = this.$route;
            if(route.path.indexOf('external') !== -1){
                this.fullScreen = true;
            }
            const q = JSON.parse(JSON.stringify(route.query));
            if (q.size) {
                this.listParam.size = Number(q.size);
                this.listParam.current = Number(q.current);
            }
            this.reload();
            this.haveRight();
        }

        haveRight() {
          const right = this.$store.state.userRights;
          right.forEach((e: any) => {
            if (e.name == "sys_mechanism_delete") {
              this.sysMechanismDelete = true;
            }
          })
        }
        onExportExcel() {
            const loading = this.$loading({
                text: '正在导出Excel',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const listParam = JSON.parse(JSON.stringify(this.listParam));
            this.listParam.size = this.listTotal;    //将表格长度变成数据总长度
            this.listParam.current = 1;          //显示第一页
            this.list(() => {
                this.exportExcel(() => {
                    this.listParam = listParam;    //表格长度还原
                    this.list(null);
                    loading.close();
                },'单位列表.xlsx');
            });
        }
        activated(){
            if (this.$route.meta && !this.$route.meta.isBack) {
                this.showForm = false;
                this.reset();
            }else{
                this.list(null);
            }
            this.tableClearSelect();
        }
        tableClearSelect(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
        }

        reload() {
            const organizationType = this.$route.params.mode;   //100 未审核单位列表  200 绑定单位备选列表
            const authedUser = this.userData = this.$store.state.AuthedUser;
            if (organizationType === '0005' || organizationType === 'self') {
                this.propParams.organizationId = authedUser.organizationId;
            }
            this.propParams.region = authedUser.organizationRegion;
            this.propParams.organizationType = organizationType;
            this.status = this.$route.params.mode == '100' ? '0' : '1';
            this.bindList = this.$route.params.mode == '200' ? '1' : '0';
            this.manufacture = this.$route.params.mode == '300' ? '1' : '0';
            this.listDict();
            if (this.bindList == '1') {
                this.loadDetail();
            } else {
                this.getConfig();
            }
        }
        //是否是授权机构
        isAuthMechanism(){
            return this.updateFrom.types.indexOf("0006") > -1 || this.updateFrom.types.indexOf("0008") > -1;
        }
        showSub(){
            if(this.status == "1" && this.bindList == "0" && this.propParams.organizationType != '0005' && this.propParams.organizationType != 'self'){
                return true
            }
            if(this.bindList == "1" && !this.userData.organizationId && this.userLoginInfoStatus !== 3){
                return true
            }
            if(this.status == "0"){
                return true
            }
            return false;
            // propParams.organizationType != '0005' || (bindList == '1' && !userData.organizationId && userLoginInfoStatus !== 3)"
        }
        closeFail(){
            this.failDialog = false;
            this.failText = "";
        }

        modifyBtn() {
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    const param = {
                        id: this.updateFrom.id,
                        code: this.updateFrom.code,
                        ownSystem: this.updateFrom.ownSystem,
                        name: this.updateFrom.name,
                        region: this.updateFrom.region,
                        residence: this.updateFrom.residence,
                        userName: this.updateFrom.userName,
                        userMobile: this.updateFrom.userMobile,
                        location: this.updateFrom.location,
                        postalAddress: this.updateFrom.postalAddress,
                        type:  this.propParams.organizationType === '0000' ? ','+this.updateFrom.types.join(",")+',' :  null,
                        principal: this.updateFrom.realName,
                        principalCard: this.updateFrom.principalCard,
                        landline: this.updateFrom.landline,
                        level: null,
                        empower: this.updateFrom.empower,
                        corporate: this.updateFrom.corporate,
                        officialSeal: this.updateFrom.officialSeal,
                        loginName: this.updateFrom.loginName,
                        email: this.updateFrom.email,
                        postcode: this.updateFrom.postcode,
                        fax: this.updateFrom.fax,

                    };
                    if(this.propParams.organizationType === '0000'){
                        param.level = (this.updateFrom.types.indexOf('0001') > -1 || this.updateFrom.types.indexOf('0002') > -1) ? this.updateFrom.level : null;
                    }
                    mechanismApi.modify(param).then((data) => {
                        if (data.data.result === 0) {
                            this.$message.success("编辑成功");
                            this.closeModal();
                            this.handleClick();
                        }
                    });
                }
            })
        }

        listDict() {
            //单位类别
            dictApi.listDictItem({typeCode: "dwlb"}).then((r) => {
                if (r.data.result === 0) {
                    const mechanismTypeData = {} as any;
                    const dataList = r.data.data;
                    this.mechanismTypeList = dataList;
                    dataList.forEach((d: any) => {
                        mechanismTypeData[d.dictKey] = d;
                    });
                    mechanismTypeData['self'] = {dictValue: '所在单位管理'};
                    mechanismTypeData['0005'] = {dictValue: '所在单位管理'};
                    mechanismTypeData['0000'] = {dictValue: '全部单位管理'};
                    mechanismTypeData['0009'] = {dictValue: '标准物质生产单位管理'};
                    this.mechanismTypeData = mechanismTypeData;
                }
            });

            //单位级别
            dictApi.listDictItem({typeCode: "dwjb"}).then((r) => {
                if (r.data.result === 0) {
                    const levelData = {} as any;
                    const dataList = r.data.data;
                    this.levels = dataList;
                    dataList.forEach((d: any) => {
                        levelData[d.dictKey] = d;
                    });
                    this.levelData = levelData;
                }
            });
        }
        listTypeName(ids:string){
            const arr = ids?ids.split(","):[];
            const arr2 = [] as any;
            arr.forEach((e:any)=>{
                const obj = this.mechanismTypeList.find((e2:any)=>e2.dictKey == e) as any;
                if(obj){
                    arr2.push(obj.dictValue);
                }
            })
            return arr2.length>0?arr2.join(","):"-";
        }

        handleChange(value: any) {
            this.propParams.region = value.join(",");
        }

        handleUpdateChange(value: any) {
            this.updateFrom.region = value.join(",").replace(/\s+/g, "");
        }

        reset(){
            for(const f in this.form){
                this.form[f] = "";
            }
            this.refresh();
        }
        refresh() {
            this.listParam.current = 1;
            this.list(null);
        }

        down(row: any) {
            try {
                var obj=JSON.parse(row);
                if(typeof obj == 'object' && obj ){
                    window.open(baseUrl + "/file/download?file=" + obj[0].url + "&name=" + obj[0].name, '_blank');
                    return true;
                }else{
                    return false;
                }
            } catch(e) {
                window.open(baseUrl + "/file/download?file=" + row + "&name=影印件", '_blank');
                return false;
            }
        }
        toAuthorizeCertList(ownerId: number) {
            const firstRouterText = this.$route.path.split("/")[1];
            this.$router.push(`/${firstRouterText}/cert/list/This_Unit/CUR/AuthorizeCert/${ownerId}`);
        }

        showModal(mode: string, row: any) {
            if (mode === 'name') {
                this.mechanismDetail.detail = row;
                this.mechanismDetail.visible = true;
            } else if (mode === 'certCount') {
                this.toAuthorizeCertList(row.id)
            } else if (mode === 'splitNameCount') {
                this.mechanismNameDetail.visible = true;
                this.mechanismNameDetail.mechanismId = row.id;
                this.listMechanismName(row.id);
            }else if (mode === 'update') {
                this.updateFrom = row;
                this.updateFrom.regions = row.region.split(",");
                const arr = row.type?row.type.split(",").filter((x:any)=>x!=''):[];
                this.$set(this.updateFrom,"types",arr);
                this.mechanismDetail.updateVisible = true;
            }else if (['remove', 'cancel', 'restore'].indexOf(mode) > -1){
              this.removeMechanism(mode, row.id, row.code, row.name);
            }
        }
        memberSelectExamine(selection: any, row: any) {
            this.allSelectedExamine = selection;
        }
        closeMechanismNameDialog(){
            this.mechanismNameDetail.updateVisible = false;
            this.mechanismNameDetail.item.name = "";
            this.mechanismNameDetail.item.id = 0;
        }
        closeMechanismNameListDialog(){
            this.mechanismNameDetail.visible = false;
            this.list(null);
            this.mechanismNameList = [];
            this.mechanismNameDetail.item = {
                id:0,
                name:"",
                mechanismId:"",
            };
            this.mechanismNameDetail.mechanismId ="";
            this.allSelectedExamine = [];
        }
        listMechanismName(ownerId:string){
            mechanismNameApi.list({ownerId: ownerId}).then(r=>{
                if (r.data.result === 0) {
                    this.mechanismNameList = r.data.data;
                }
            })
        }
        addMechanismNameBtn(){
            this.mechanismNameDetail.updateVisible = true;
        }
        updateMechanismNameBtn(){
            const dataArr = this.allSelectedExamine as any;
            if(dataArr.length == 0){
                this.$message.error("请先勾选");
                return;
            }
            if(dataArr.length > 1){
                this.$message.error("只能勾选一条");
                return;
            }
            this.mechanismNameDetail.updateVisible = true;
            this.mechanismNameDetail.item = JSON.parse(JSON.stringify(dataArr[0]));
        }
        memberTableClearSelect(){
            this.allSelectedExamine = [];
            let $table = this.$refs.memberTable as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
        }
        updateMechanismName(){
            const item = this.mechanismNameDetail.item;
            if(item.name.length==0){
                this.$message.error("名称不能为空");
                return;
            }
            if(item.id >0){
                mechanismNameApi.update(item).then(t=>{
                    if (t.data.result === 0) {
                        this.$message.success("修改成功");
                        this.closeMechanismNameDialog();
                        this.listMechanismName(item.mechanismId);
                        this.memberTableClearSelect();
                    }
                })
            }else {
                item.mechanismId = this.mechanismNameDetail.mechanismId;
                mechanismNameApi.add(item).then(t=>{
                    if (t.data.result === 0) {
                        this.$message.success("添加成功");
                        this.closeMechanismNameDialog();
                        this.listMechanismName(item.mechanismId);
                    }
                })
            }


        }
        deleteMechanismName(){
            const dataArr = this.allSelectedExamine as any;
            if(dataArr.length==0) {
                this.$message.error("请先勾选");
                return;
            }
            this.$confirm('确定要删除'+dataArr.flatMap((e:any)=>e.name).join(",")+'？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                mechanismNameApi.delete({ids:dataArr.flatMap((e:any)=>e.id).join(",")}).then((data) => {
                    if (data.data.result === 0) {
                        this.$message.success("删除成功");
                        this.listMechanismName(this.mechanismNameDetail.mechanismId);
                    }else if(data.data.result === 1){
                        this.$alert(data.data.message, '以下位置正在使用，无法删除', {
                            dangerouslyUseHTMLString: true
                        });
                    }
                });
            }).catch(() => {
                console.log("取消")
            });
        }

        closeModal() {
            this.mechanismDetail.detail = null;
            this.mechanismDetail.visible = false;
            this.mechanismDetail.updateVisible = false;
            this.updateFrom = null;
            this.certDetail.visible = false;
            this.certDetail.list = [];
        }

        getConfig() {
            const organizationType = this.propParams.organizationType;
            userApi.getUserConfig({name: "mechanismPageSize-" + organizationType}).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    if (rData) {
                        this.listParam.size = Number(rData.config);
                    }
                    this.list(null);
                }
            })
        }

        changeTabCol(e: any) {
            this.load = false;
            this.tabCol = e;
            this.$nextTick(()=>{
                this.load = true;
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }

        indexMethod(index: any) {
            return (this.listParam.current - 1) * this.listParam.size + index + 1;
        }
        //判断是否可以选择单位类别
        judge1(){
            return this.propParams.organizationType === '0000' || this.propParams.organizationType === '0005' || this.propParams.organizationType === 'self' || this.status === "0" || this.bindList === "1"
        }
        list(callback: any) {
            if(this.bindList === '1' && this.form.name.length < this.leastNumber && !this.userData.organizationId){
                this.$message.warning("请至少输入"+this.leastNumber+"个字符后进行查询");
                return
            }
            const route = this.$route;
            let q = JSON.parse(JSON.stringify(route.query));
            q = Object.assign(q, this.listParam);
            for (const key in q) {
                q[key] = String(q[key]);
            }
            // if(JSON.stringify(q) != JSON.stringify(route.query)) {
            //     this.$router.replace({name: route.name!, query: q})
            // }
            const params = {
                ...this.listParam,
                ...this.form,
                region: this.status === "0" ? null : this.propParams.region,
                organizationId: (['0005', 'self'].indexOf(this.propParams.organizationType) > -1 ) ? this.propParams.organizationId : null,
                // organizationType: (this.propParams.organizationType === '0000' || this.propParams.organizationType === '0005' || this.status === "0" || this.bindList === "1" || this.manufacture === "1") ? null : this.propParams.organizationType,
                status: this.status,
                source: this.manufacture === '1'?'1':null,
                // precise: this.bindList === '1'?'1':null
            }
            if(this.judge1() || this.manufacture === '1'){
                console.log(params.organizationType)
                // params.organizationType = null;
            }else{
                params.organizationType = this.propParams.organizationType;
            }
            this.load = false;
            if (this.bindList === "1" && this.userData.organizationId) {//用户已经绑定了所以只看到本单位的信息
                params.organizationId = this.userData.organizationId;
            }
          if (this.propQuery) {
            params.organizationType = this.propQuery.organizationType;
            params.warnStatus = this.propQuery.warnStatus;
          }
            let api;
            if(this.manufacture=="1"){
                api = mechanismApi.list3({
                    ...this.listParam,
                    ...this.form,
                    source: 1,
                    status: 1,
                    isStatus: 0,
                    organizationType : "0007",
                })
            }else{
                api = mechanismApi.list(params)
            }

            //如果未绑定人员搜索条件为空，则不展示列表内容
            if(this.unbound && this.form.name == ""){
                this.load = true;
                return
            }

            api.then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.listTotal = r.data.data.total;
                    this.listData = rData;
                    this.$nextTick(()=>{
                        let $table = this.$refs.table as HTMLFormElement;
                        if($table){
                            $table.doLayout();
                        }
                        if(callback){
                            callback();
                        }
                    })
                }
                this.$nextTick(() => {
                    this.load = true;
                })
            })
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
            userApi.updateUserConfig({name: "mechanismPageSize-" + this.propParams.organizationType, config: val})
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list(null);
        }

        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }

        bindUnit() {
            const dataArr = this.allSelected as any;
            if (dataArr.length == 0) {
                this.$message.error("请先勾选");
                return;
            }
            if (dataArr.length > 1) {
                this.$message.error("只能勾选一个单位");
                return;
            }
            userApi.bind({userId: this.userData.id, orgId: dataArr[0].id}).then((r: any) => {
                if (r.data.result === 0) {
                    this.userData.organizationId = dataArr[0].id;
                    this.userLoginInfoStatus = 3;
                    this.userData.status = "3";
                    sessionStorage.setItem('AuthedUser', JSON.stringify(this.userData));
                    this.$message.success("绑定申请成功");
                    this.handleClick();
                }
            })
        }

        unbind() {
            this.$confirm('确定要解绑单位吗？解绑后需要重新登录。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                userApi.unBind({}).then((r: any) => {
                    if (r.data.result === 0) {
                        this.$message.success("解绑成功");
                        this.$router.push("/login");
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }

        changeApply(){ // 变更申请
          this.changeApplyDialog.visible = true;
        }
        bindUpdateBtn(mode: string) {
            const dataArr = this.allSelected as any;
            if (dataArr.length == 0) {
                this.$message.error("请先勾选");
                return;
            }
            if (dataArr.length > 1) {
              this.$message.error("只能勾选一个单位");
              return;
            }
            // if(['batch-enable', 'batch-disable'].indexOf(mode) === -1){
                this.showModal(mode, dataArr[0]);
            // }else{
                // const ids = dataArr.flatMap( (e: any) => e.id);
                // const activeStatus = "batch-enable" === mode ? 1 : 2;
                // this.batchEditActiveStatus(activeStatus, ids);
            // }
        }
        batchEditActiveStatus(activeStatus: number, list: Array<string>) {
          this.$confirm('您勾选了'+ list.length +'条数据，确定要将单位状态切换到【' + (activeStatus === 1 ? '正常' : '禁用') +'】吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            mechanismApi.batchEditActiveStatus(activeStatus, list).then((r: any) => {
              if(r.data.result === 0) {
                this.$message.success("操作成功!");
                this.handleClick();
              }
            });

          });

        }

        removeMechanism(mode: string, mechanismId: string, code: string, name: string){
          let confirmStr = "";
          if(mode === 'remove'){
            confirmStr = `确定要删除【${name}】单位吗？`;
          }else if(mode === 'cancel'){
            confirmStr = `确定要注销【${name}】单位吗？`;
          }else if(mode === 'restore'){
            confirmStr = `确定要恢复【${name}】单位吗？`;
          }
          this.$confirm(confirmStr, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            mechanismApi.removeMechanism(mode, mechanismId, code).then((r: any) => {
              if (r.data.result === 0) {
                this.$message.success("操作成功");
                this.handleClick();
              }
            });
          })
        }

        // @Watch("$route.path")
        // get$routePath() {
        //     this.reload()
        // }

        goBack() {
            this.closePage();
        }

        handleClick() {
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if ($table) {
                $table.clearSelection();
            }
            this.list(null);
        }

        //通过或不通过
        passOrNot(status: number) {
            let reason = "";
            //通过或不通过
            if (status == 2) {
                const reasons = this.$refs.reasons as HTMLFormElement;
                reason = reasons.getText();
                //不通过，必须有原因
                if (reason == "") {
                    this.$message.error("请填写不通过原因");
                    return
                }
            }
            mechanismApi.passOrNot({orgId: this.mechanismDetail.detail.id, status: status, reason: reason}).then(r => {
                if (r.data.result === 0) {
                    this.$message.success("审核成功");
                    this.failDialog = false;
                    this.mechanismDetail.visible = false;
                    this.handleClick();
                }
            })
        }

        unbound = false;
        loadDetail() {
            userApi.loadDetail({id: this.userData.userId}).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data as any;
                    if (rData.userLoginInfo) {
                        this.userData.organizationId = rData.userLoginInfo.organizationId;
                        this.userLoginInfoStatus = rData.userLoginInfo.status;
                    }
                    //如果未绑定单位，不默认查询
                    if(this.userData.organizationId){
                        this.unbound = false;
                        this.handleClick();
                    }else{
                        this.unbound = true;
                    }
                }
            })
        }

        //制造单位******
        addName = "";
        editId = "";
        editData = "";
        setDialog = false;
        addManufacture() {
            this.addName = "";
            this.editId = "";
            this.setDialog = true;
        }
        saveSuccess(){
            this.setDialog = false;
            this.list(null);
        }
        resetAddform(){
            this.addName = "";
            this.editId = "";
        }
        //0新增  1编辑 2查看  3删除
        toDetailmanu(type: number){
            this.resetAddform();
            const dataArr = this.allSelected as any;
            let id = "";
            if(type !== 0){
                if(dataArr.length == 0){
                    this.$message.error("请先勾选");
                    return;
                }
                if(type == 3){
                    this.del2(dataArr);
                    return;
                }
                if(dataArr.length > 1 && (type == 1 || type == 2)){
                    this.$message.error("只能勾选一条");
                    return;
                }
                id = dataArr[0].id;
            }
            if(id != "0"){
                this.edit(dataArr[0]);
            }
            this.setDialog = true;
        }
        edit(data: any) {
            this.addName = data.name;
            this.editId = data.id;
            this.editData = data;
            this.setDialog = true;
        }

        del2(dataArr: any){
            this.$confirm('确定要删除'+dataArr.flatMap((e:any)=>e.name).join(",")+'？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                manufactoryApi.delete({ids: dataArr.flatMap((e:any)=>e.id).join(",")}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.handleClick();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        //制造单位end******

        onTag(mode: string, data: any){
            const firstRouterText = this.$route.path.split("/")[1];
            switch (mode) {
                case "standardCount": {
                    this.$router.push(`/${firstRouterText}/measuring/list/This_Unit/CUR/Standard/${data.id}`);
                    break;
                }
                case "standardItemCount": {
                    this.$router.push(`/${firstRouterText}/measuring/list/This_Unit/CUR/Item/${data.id}`);
                    break;
                }
                case "publicStandardCount": {
                    this.$router.push(`/${firstRouterText}/public/list/This_Unit/CUR/${data.id}`);
                    break;
                }
                case "certCount": {
                    this.$router.push(`/${firstRouterText}/cert/list/This_Unit/CUR/AuthorizeCert/${data.id}`);
                    break;
                }
                case "certItemCount": {
                    this.$router.push(`/${firstRouterText}/cert/list/This_Unit/CUR/AllItem/${data.id}`);
                    break;
                }
                case "instrCount": {
                    this.$router.push(`/${firstRouterText}/instrumentCompany/list/1/0/0/${data.id}`);
                    break;
                }
            }
            return;
        }

      //章上传
      handleSealSuccess(res: any, fileny: any) {
        if (res.result === 0) {
          const rData = res.data;
          this.updateFrom.officialSeal = rData;
          this.$message.success("上传成功");
        }
      }

        //法人证书上传
        handleCorporateSuccess(res: any, fileny: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.updateFrom.corporate = rData;
                this.$message.success("上传成功");
            }
        }

      handleEmpowerSuccess(res: any, fileny: any) {
        if (res.result === 0) {
          const rData = res.data;
          this.updateFrom.empower = rData;
          this.$message.success("上传成功");
        }
      }

        //图片上传判断
        beforeImageUpload(file: any) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            if (!isJPG && !isPNG) {
                this.$message.error('上传图片只能是 JPG 或 PNG格式!');
            }
            return (isJPG || isPNG);
        }
      isPhoneShow(){
        if(this.propParams.organizationType === '100' || this.propParams.organizationType === '0000'){
          return true;
        }
        const authedUser = this.userData;
        if(this.propParams.organizationType == '0004' && authedUser.organizationType && authedUser.organizationType.includes("0002")){
          return true;
        }
        return false;
      }
    }
